import { Users, Briefcase, Building2, ShieldCheck, Calculator, Rocket, ArrowUpRight } from "lucide-react";
import { Chapter, Reveal, scrollToId } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Users, Briefcase, Building2, ShieldCheck, Calculator, Rocket };

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 border-t border-white/10" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Chapter num="Chapter 03" label="What We Do" />
            <h2 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight font-medium text-white max-w-xl">
              99+ services. One accountable team.
            </h2>
          </div>
          <button
            onClick={() => scrollToId("#contact")}
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-orange-400 transition-colors"
            data-testid="services-cta"
          >
            Discuss your requirement <ArrowUpRight className="w-4 h-4" />
          </button>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.num} delay={(i % 3) * 0.1} className={s.span}>
                <div
                  className="group relative h-full bg-zinc-900 border border-zinc-800 hover:border-primary/50 p-8 md:p-10 flex flex-col justify-between min-h-[260px] transition-colors duration-500"
                  data-testid={`service-card-${s.num}`}
                >
                  <div className="flex items-start justify-between">
                    <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    <span className="font-heading text-sm text-zinc-600 group-hover:text-primary transition-colors duration-500">
                      /{s.num}
                    </span>
                  </div>
                  <div className="mt-10">
                    <h3 className="font-heading text-2xl md:text-3xl font-medium text-white mb-3">
                      {s.title}
                    </h3>
                    <p className="text-zinc-400 text-sm md:text-base leading-relaxed max-w-lg">
                      {s.desc}
                    </p>
                    <div className="mt-6 flex flex-wrap gap-2">
                      {s.tags.map((t) => (
                        <span
                          key={t}
                          className="text-xs px-3 py-1 border border-white/10 text-zinc-400"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
